<!-- 召回通知单列表 -->
<template>
    <div class='page_content'>
        <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="100%">
            <retailWebPoolAction v-if="showStatus" ref="retailWebPoolAction" @drawerCancel="drawerCancel" @toDetail="toDetail" :actionData="actionData"></retailWebPoolAction>
        </el-drawer>
        <subComponents ref="showSelectData"></subComponents>
        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
            <div class="page_content_top_line">
                <vSearch @searchData="searchData" :flagList="['shopNo']" @openSearchs="openSearch" :getRequestData=getRequestData v-if="pageShowData.jurHead" :searchList=pageShowData.jurHead.jurconfigform>
                    <template slot="searchInput" slot-scope="{formOneValue}">
                        <el-select clearable size="mini" v-if="formOneValue.entityField == 'shopNo'" v-model="getRequestData[formOneValue.entityField]" placeholder="请选择">
                            <el-option v-for="item in shopList" :key="item.shopId" :label="item.shopName" :value="item.shopId"></el-option>
                        </el-select>
                    </template>
                </vSearch>
            </div>
        </div>
        <div class="page_content_center">
            <el-table @selection-change="handleSelectionChange" size="mini" v-if="pageShowData.jurTableVo" :data="returnData.list" :height="(tableHeight / 2)" :key="$store.state.tableNum" border style="width: 100%"
                      @row-click="rowClick" :row-class-name="rowClassName" @sort-change="sortChange">
                <el-table-column align="center" width="50" type="selection"></el-table-column>
                <el-table-column align="center" v-if="tableValye.isShow == 1" show-overflow-tooltip :min-width="tableValye.fieldWeight" v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable"
                                 :key="tableKey" :prop="tableValye.entityField" :label="tableValye.showField" :sortable="tableValye.isSort == 1 ? 'custom' : false">
                    <template slot-scope="scope">
                        <span v-if="tableValye.fieldType == 'date'">
                            <span v-if="scope.row[tableValye.entityField]">
                                {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                            </span>
                        </span>
                        <span v-else-if="tableValye.isRift == 1">
                            <a @click="toDetail(scope.row[tableValye.riftField])">{{ scope.row[tableValye.entityField]
                                }}</a>
                        </span>
                        <span v-else-if="tableValye.entityField == 'createTime'">
                            <span v-if="scope.row[tableValye.entityField]">
                                {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                            </span>
                        </span>

                        <el-tag v-else-if="tableValye.entityField == 'state'" size="mini" type="primary">
                            {{ $common.getIsGsp(tableValye.formatterContent, scope.row[tableValye.entityField]) }}</el-tag>
                        <span v-else-if="tableValye.fieldType == 'formatter'">
                            {{ $common.getIsGsp(tableValye.formatterContent,
                                scope.row[tableValye.entityField])
                            }}
                        </span>
                        <span v-else>
                            {{ scope.row[tableValye.entityField] }}
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
        </div>
        <el-table v-if="pageShowData.jurFormVoList.length > 0" class="table1" :data="returnData.detailsList" :height="(tableHeight / 2)" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row
                  size="mini">
            <el-table-column align="center" v-if="tableValye.isShow == 1" v-for="(tableValye, tableKey) in pageShowData.jurFormVoList[0].jurconfigform" :key="tableKey" show-overflow-tooltip
                             :min-width="tableValye.fieldWeight" :prop="tableValye.entityField" :label="tableValye.showField">
                <template slot-scope="scope">
                    <span v-if="tableValye.fieldType == 'date'">
                        <span v-if="scope.row[tableValye.entityField]">
                            {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                        </span>
                    </span>
                    <el-tag size="mini" v-else-if="tableValye.entityField == 'isWms'">
                        {{ scope.row.isWms == 0 ? '否' : '是' }}
                    </el-tag>
                    <span v-else-if="tableValye.isRift == 1">
                        <a @click="toDetail(scope.row[tableValye.riftField])">{{
                            scope.row[tableValye.entityField] }}</a>
                    </span>
                    <el-tag v-else-if="tableValye.fieldType == 'formatter'" size="mini">
                        {{ $common.getIsGsp(tableValye.formatterContent, scope.row[tableValye.entityField])
                        }}</el-tag>
                    <span v-else>
                        {{ scope.row[tableValye.entityField] }}
                    </span>
                </template>
            </el-table-column>
        </el-table>
        <!-- 自定义设计 -->
        <customDesign ref="customDesign"></customDesign>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" width="800px">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" />
        </el-dialog>
        <el-dialog :title="orderTitle" v-if="orderShow" :visible.sync="orderShow" width="1200px">
            <div v-for="(item, index) in formList" :key="index">
                <el-divider content-position="left">{{ sendDataList[index].storeName }}</el-divider>
                <el-form inline :model="sendDataList[index]" :ref="`sendDataInfo${index}`" label-width="80px" class="demo-ruleForm">
                    <el-form-item label="收款台" prop="deskId">
                        <el-select class="input" v-model="sendDataList[index].deskId" placeholder="请选择">
                            <el-option v-for="(val, key) in item.deskList" :key="key" :label="val.name" :value="val.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="账簿名称" prop="bookId">
                        <el-select class="input" v-model="sendDataList[index].bookId" placeholder="请选择">
                            <el-option v-for="(val, key) in item.bookList[sendDataList[index].deskId]" :key="key" :label="val.name" :value="val.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="收银员" prop="cashierId">
                        <el-select class="input" v-model="sendDataList[index].cashierId" placeholder="请选择">
                            <el-option v-for="(val, key) in item.cashierList" :key="key" :label="val.name" :value="val.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="销售员" prop="salesPersonId">
                        <el-select class="input" v-model="sendDataList[index].salesPersonId" placeholder="请选择">
                            <el-option v-for="(val, key) in item.salesPersonList" :key="key" :label="val.name" :value="val.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" @click="closeClick">取 消</el-button>
                <el-button size="mini" type="primary" @click="openClick">保 存</el-button>
            </span>
        </el-dialog>
        <printPlan ref="printPlan"></printPlan>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import retailWebPoolAction from '@/components/retailWebPoolAction.vue'
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
        retailWebPoolAction
    },
    data() {
        //这里存放数据
        return {
            tableHeight: 0,
            getRequestData: {},
            returnData: {
                total: 0, // 总条数
                list: [],
                detailsList: [],
            },
            selectedDataIndex: 0,
            multipleSelection: [],
            buttonList: [],
            pageShowData: [],
            formDataList: [],
            showStatus: false,
            actionData: {},
            seId: "",
            dialogTitle: "",
            seWidth: "",
            seTitle: "",
            DialogVisible: false,
            smId: "",
            sField: "",
            parentSearchData: {},
            //--------------------------
            orderTitle: "",
            orderShow: false,
            shopData: {},
            formList: [],
            sendDataInfo: {
                bookId: "",//账簿
                cashierId: "",//收银员
                deskId: "",//款台
                salesPersonId: "",//销售员
                storeId: "",//门店
            },
            sendDataList: [],
            shopList: [],
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        showPrintPlan(list) {
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                this.$refs.printPlan.openDia(list, "printData/retailOrderPrint", 1609378973359, '', 'all')
            } else {
                return
            }
        },
        handleSelectionChange(val) {
            this.multipleSelection = val
        },
        sortChange(column) {
            this.returnData.list = this.$common.sortChange(column, this.returnData.list, this.pageShowData.jurTableVo.jurconfigtable, 'entityField')
        },
        rowClick(row) {
            this.selectedDataIndex = row.index
            this.getDetailsList()
        },
        rowClassName({ row }) {
            let rowName = ""
            if (row.index == this.selectedDataIndex) {
                rowName = "rowStyle"
            }
            return rowName; //也可以再加上其他类名 如果有需求的话
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField) {
            if (type == 'salesName') {
                if (this.getRequestData.smId == undefined || this.getRequestData.smId == '') {
                    return this.$message({
                        message: "请先选择单位",
                        type: "error",
                    });
                } else {
                    this.parentSearchData.smId = this.getRequestData.smId
                }
            }
            this.sField = sField;
            this.DialogVisible = true;
            this.seId = sId;
            this.parentSearchData[type] = this.getRequestData[type];
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.getRequestData[item] = val[item]
            })
        },
        // 初始化赋值字段值
        initParamValue(setField) {
            let arr = setField.split(',')
            arr.forEach(item => {
                this.$set(this.getRequestData, item, "")
            })
        },
        // 清空赋值字段
        claerValue(field, pField) {
            if (this.getRequestData[field] == '') {
                this.initParamValue(pField)
            }
        },
        // 检索方案带回数据
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.paramValue(val)
            }
        },

        // 子组件触发
        drawerCancel(e, list) {
            this.showStatus = false
            if (e == 1) {
                this.showPrintPlan(list)
                this.getDataList()
            }
        },
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页    
                var isPenetrate = true
                // 设置缓存 存入点击单号
                this.resetSetItem('penetrateOrderId', orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage({ //向窗口发送MessageEvent消息
                    cmd: 'returnFormJson',
                    params: {
                        isPenetrate
                    } //参数
                }, '*');
            }
            this.getPageInfo()
        },
        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1;
                this.getRequestData.end = time;
            }
        },
        
        isShowData(name, value) {
            switch (name) {
                case "ovmApper":
                    var dataInfo = JSON.parse(sessionStorage.getItem("selectUserData"));
                    this.getRequestData.ovmApper = dataInfo.opmId;
                    this.getRequestData.opmName = dataInfo.opmName;
                default:
                    this.getRequestData[name] = value;
            }
        },

        // 获取数据列表
        async getPageInfo() {
            var pathId = parent.getMenuInfo(this.$route.path);
            let responseData = await this.$http.getJur({
                ids: [pathId.jurId]
            });
            if (responseData.status == 200) {
                this.pageShowData = responseData.result;
                var obj = {}
                if (this.pageShowData.jurHead) {
                    obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
                } else {
                    obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
                }
                for (const key in obj) {
                    this.$set(this.getRequestData, key, obj[key])
                }
                this.getButtonList();
                this.getDataList();
                this.queryShopList()
                this.getJur()
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        async getJur() {
            let responseData = await this.$http.getJur({
                ids: [16093789733581]
            });
            if (responseData.status == 200) {
                this.formDataList = responseData.result.jurFormVoList
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        clear(val) {
            if (val) {
                var arr = val.split(",")
                arr.forEach(item => {
                    this.$set(this.getRequestData, item, "")
                })
            }
        },
        // 动作集合
        actionSet(actionData) {
            console.log(actionData.actionType, 'actionData.actionType');

            switch (actionData.actionType) {
                case 12:
                    if (this.multipleSelection.length == 0) {
                        return this.$message.error('请选择需要退货的数据')
                    }
                    this.onSubmit()
                    break;
                case 13:
                    if (this.multipleSelection.length != 1) {
                        return this.$message.error('请选择一条数据')
                    }
                    this.queryDetails(1)
                    break;
                case 10:
                    if (this.multipleSelection.length == 0) {
                        return this.$message.error('请选择数据')
                    }
                    this.orderTitle = "下单"
                    this.queryShop()
                    break;
                case 11:
                    if (this.multipleSelection.length == 0) {
                        return this.$message.error('请选择数据')
                    }
                    this.orderTitle = "店内下单"
                    this.queryShop()
                    break;
                case 14:
                    this.orderTitle = "默认配置"
                    this.queryShop()
                    break;
                case 15:
                    this.getRequestData.ormId = sessionStorage.getItem("ormId")
                    window.location.href = `${window.global_config.BASE_URL}/orderpool/exportWebRetailOrderDetail${this.$common.getUrl(this.getRequestData)}`
                    break;
                case 6:
                    if (this.multipleSelection.length == 0) {
                        return this.$message.error('请选择数据')
                    }
                    this.cancellation()
                    break;
            }
        },
        onSubmit(){
            this.$confirm('是否提交退货?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                const res = await this.$http.retailWebgenOrderRejByOriginOrder({ ids: this.multipleSelection.map(item => item.retailId) })
                if (res.status == 200) {
                    this.$message({
                        type: 'success',
                        message: res.message,
                    });
                    this.getDataList()
                } else {
                    this.$message({
                        type: 'error',
                        message: res.message,
                    });
                }
            }).catch(() => {
            });
        },
        cancellation() {
            this.$confirm('是否作废该数据?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                const res = await this.$http.orderpooldisAbleO2O({ ids: this.multipleSelection.map(item => item.orderId) })
                if (res.status == 200) {
                    this.$message({
                        type: 'success',
                        message: res.message,
                    });
                    this.getDataList()
                } else {
                    this.$message({
                        type: 'error',
                        message: res.message,
                    });
                }
            }).catch(() => {
            });
        },
        async queryDetails(val) {
            const res = await this.$http.retailWebgetRejFtInfo({ ids: [this.multipleSelection[0].orderId] })
            console.log(res);

            if (res.status == 200) {
                this.actionData = {
                    cate: 1,
                    formData: this.formDataList,
                    oldData: res.result,
                    orderId: this.multipleSelection[0].orderId,
                    isStore: val,
                    isType:1,
                    printSouce: '',
                    printJurId: ''
                }
                this.showStatus = true
            } else {
                this.$message.error(res.message)
            }
        },
        async queryShop() {
            let res;
            if (this.orderTitle == '默认配置') {
                //retailWebgetStoreDefaultConfig
                res = await this.$http.retailWebgetStoreDefaultConfig()
            } else {
                res = await this.$http.retailWebgetStoreConfig({ ids: this.multipleSelection.map(item => item.orderId) })
            }
            if (res.status == 200) {
                this.formList = res.result
                this.sendDataList = []
                this.formList.forEach(item => {
                    let deskId = "";
                    let bookId = "";
                    if (item.deskList.length > 0) {
                        deskId = item.deskList[0].id
                    }
                    if (item.bookList[deskId] != undefined) {
                        bookId = item.bookList[deskId][0].id
                    }
                    var obj = {
                        bookId: bookId,//账簿
                        cashierId: item.cashierList.length > 0 ? item.cashierList[0].id : '',//收银员
                        deskId: deskId,//款台
                        salesPersonId: item.salesPersonList.length > 0 ? item.salesPersonList[0].id : '',//销售员
                        storeId: item.storeId,//门店
                        storeName: item.storeName,//门店名称
                    }
                    this.sendDataList.push(obj)
                })
                this.orderShow = true
            } else {
                this.$message.error(res.message)
            }
        },
        closeClick() {
            this.orderShow = false
        },
        async openClick() {
            const params = {
                orderIdList: this.multipleSelection.map(item => item.orderId),
                storeConfigList: this.sendDataList
            }
            let res;
            if (this.orderTitle == '下单') {
                params.isO2O=1
                res = await this.$http.retailWebgenOrder(params)
            } else if (this.orderTitle == "店内下单") {
                res = await this.$http.retailWebgenOrderStore(params)
            } else if (this.orderTitle == "默认配置") {
                const params1 = {
                    storeConfigList: this.sendDataList
                }
                res = await this.$http.retailWebsetStoreDefaultConfig(params1)
            }
            if (res.status == 200) {
                this.$message.success(res.message)
                this.orderShow = false
                if (this.orderTitle != "默认配置") {
                    this.showPrintPlan(res.result)
                }
                this.getDataList()
            } else {
                this.$message.error(res.message)
            }
        },
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)
            this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
        },
        // 数据搜索
        searchData() {
            this.getRequestData.page = 1;
            this.getDataList();
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val;
            this.getDataList();
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1;
            this.getRequestData.rows = val;
            this.getDataList();
        },

        // 获取数据列表
        async getDataList() {
            this.getRequestData.queryType=1
            let responseData = await this.$http.orderpoolqueryWebRetailOrder(this.getRequestData);
            if (responseData.status == 200) {
                this.returnData.list = this.$common.getIndex(responseData.result.list)
                this.returnData.total = responseData.result.total;
                this.selectedDataIndex = 0
                if (this.returnData.list.length > 0) {
                    this.getDetailsList()
                }
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        async getDetailsList() {
            let responseData = await this.$http.orderpoolQueryDetail({ ids: [this.returnData.list[this.selectedDataIndex].orderId] })
            if (responseData.status == 200) {
                this.returnData.detailsList = responseData.result
            }
        },
        // 获取按钮权限
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
            
        },
async queryShopList() {
            const params = {}
            const res = await this.$http.orderpoolqueryWdtShopStore(params)
            if (res.status == 200) {
                console.log(res);
                this.shopList = res.result
            }
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getPageInfo();
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}

.el-table .rowStyle {
    background: #fff7ca !important;
}

.input {
    width: 200px !important;
}

::v-deep .el-divider--horizontal {
    margin: 15px 0;
}
</style>